import React from 'react'
import { useLocation, useOutletContext, useParams } from 'react-router-dom';
import DashboardHeader from '../components/Other/DashboardHeader';
import PageHeaderTitle from '../components/pages/PageHeaderTitle';
import PerformanceSection from '../components/Other/PerformanceSection';

const PerformancePage = () => {
  const [sidebarToggle] = useOutletContext();
    const location = useLocation();
  const user_name = location.state?.user_name;


  return (
    <>
      <DashboardHeader toggle={sidebarToggle} />
      <PageHeaderTitle title={`${user_name}'s Performances`} />
      <PerformanceSection />
    </>
  );
}


export default PerformancePage
